import { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';

const navLinks = [
  { label: 'Accueil', href: '#accueil' },
  { label: 'Appartements', href: '#appartements' },
  { label: 'Tarifs', href: '#tarifs' },
  { label: 'Riquewihr', href: '#decouvrir' },
  { label: 'Avis', href: '#avis' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-cream-50/95 backdrop-blur-md shadow-sm border-b border-cream-400/30'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-20">
          <a
            href="#accueil"
            onClick={(e) => handleClick(e, '#accueil')}
            data-testid="navbar-logo"
            className={`font-display text-xl md:text-2xl font-semibold tracking-tight transition-colors duration-300 ${
              scrolled ? 'text-wine-700' : 'text-white'
            }`}
          >
            Gite Riquewihr
          </a>

          <div className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleClick(e, link.href)}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className={`font-body text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:text-wine-700 ${
                  scrolled ? 'text-earth-200' : 'text-white/90'
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:+33632345143"
              data-testid="nav-phone-link"
              className={`flex items-center gap-2 font-body text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${
                scrolled ? 'text-wine-700' : 'text-white'
              }`}
            >
              <Phone size={14} />
              <span className="hidden xl:inline">+33 6 32 34 51 43</span>
            </a>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`lg:hidden p-2 transition-colors ${
              scrolled ? 'text-earth-100' : 'text-white'
            }`}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-cream-50/98 backdrop-blur-lg border-t border-cream-400/30 animate-fade-in"
        >
          <div className="container mx-auto px-4 py-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleClick(e, link.href)}
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                className="font-body text-sm uppercase tracking-[0.2em] text-earth-200 hover:text-wine-700 py-2 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:+33632345143"
              className="flex items-center gap-2 font-body text-sm text-wine-700 py-2"
            >
              <Phone size={14} />
              +33 6 32 34 51 43
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
